// Backend root (no version suffix) — ordr-flutter hits v1/v2/v3 paths against the same host.
// In dev, calls are routed through the CRA dev-server proxy (src/setupProxy.js) at
// /api-proxy, since the backend's CORS policy only allows https://dev.ordr.exchange
// on real responses and blocks any other origin — including any localhost dev server.
const REMOTE_API_ROOT = (process.env.REACT_APP_API_URL || "https://devapi.ordr.exchange/v1").replace(/\/v1\/?$/, "");
export const API_ROOT = REMOTE_API_ROOT
export const API_URL = `${API_ROOT}/v1`;
// Same Alpha Vantage key ordrx_frontend ships with; override via env for production.
export const OIL_DATA_API_KEY = process.env.REACT_APP_OIL_DATA_API_KEY || "PA22ZUBCYXSJCDKJ";
export const AUTH_TOKEN_KEY = "BUYER_AUTH_TOKEN";
export const USER_KEY = "BUYER_USER_DETAILS";

export const ROLE_BUYER = 1;
export const ROLE_SELLER = 2;
export const ROLE_LOGISTIC = 4;

// Mirrors ordr-flutter lib/common/constants.dart bid/order status map
export const STATUS_INFO = {
	1: "Bid Created",
	2: "Buyer Approved",
	3: "Bid Confirmed",
	4: "Buyer Approves Bid",
	5: "Seller Bid Awarded",
	6: "Bid Delivered",
	7: "Bid Payment Success",
	8: "Bid Confirmation Cancelled",
	9: "Driver Requested",
	10: "Delivery Scheduled",
	11: "Delivery Rejected",
	12: "Arrived at Terminal",
	13: "Collected BOL",
	14: "Driver Received Product & Delivery",
	15: "Driver En Route to Buyer Location",
	16: "Bid Awarded from Seller",
	19: "Cancellation Requested",
	20: "Cancellation Requested",
	21: "Order Cancelled",
	22: "Order Cancelled",
	23: "Cancellation Request Rejected",
	24: "Cancellation Request Rejected",
	25: "Delivery Delayed",
	26: "Reconciliation Pending",
	27: "Payment Initiated to Seller",
	28: "Initiated Payment Failed for Seller",
	29: "Payment Initiated to Ordr",
	30: "Initiated Payment Failed for Ordr",
	31: "Payment Settlement Done to Seller",
	32: "Payment Settlement Done to Ordr",
	33: "Bid Locked Amount Released",
	34: "Order Completed",
};

export const OPEN_ORDER_STATUS_LIST = ["Confirmed", "Pending Seller Confirmation (Awarded)", "Bid Submitted"];
export const PREVIOUS_ORDER_STATUS_LIST = ["Bid Rejected", "Delivered"];

export const NAV_ITEMS = [
	{ to: "/", label: "Dashboard", icon: "grid" },
	{ to: "/locations", label: "Locations", icon: "map-pin" },
	{ to: "/bids/new", label: "New Bid Request", icon: "plus-circle" },
	{ to: "/orders", label: "Orders", icon: "package" },
	{ to: "/closed-market", label: "Closed Market", icon: "lock" },
	{ to: "/funds", label: "Funds", icon: "credit-card" },
	{ to: "/market-updates", label: "Market Updates", icon: "trending-up" },
	{ to: "/notifications", label: "Notifications", icon: "bell" },
	{ to: "/help", label: "Get Help", icon: "help-circle" },
	{ to: "/settings", label: "Settings", icon: "settings" },
];
